import axios from "../utils/axios-interceptor";

export const getProfileApi = async(payload) => {
  const res = await axios.get(`/user_token_usage/${payload.username}`);
  const data = await res.data
  return data
}